import {
  HTTP_QUOTATION_FETCHING,
  HTTP_QUOTATION_SUCCESS,
  HTTP_QUOTATION_FAILED
} from '../constants';

const initialState = {
  result: null,
  isFatching: false,
  isError: false
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_QUOTATION_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case HTTP_QUOTATION_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    case HTTP_QUOTATION_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };

    default:
      return state;
  }
};
